// Dev uniquement : connexion directe aux comptes du seed Supabase local (supabase/seed.sql, mot de
// passe "password"). Double garde : build de dev ET Supabase local — jamais affiché contre la prod,
// et éliminé du build de production (NODE_ENV y vaut 'production').
import { supabase } from '../supabaseClient';

export const DEV_LOGIN_ENABLED =
  process.env.NODE_ENV === 'development' &&
  /^http:\/\/(127\.0\.0\.1|localhost)[:/]/.test(process.env.REACT_APP_SUPABASE_URL || '');

export const DEV_LOGIN_USERS = [
  { email: 'manager@local.test', label: 'Manager Local (manager)' },
  { email: 'claire@local.test', label: 'Claire Validatrice (manager, valide les congés)' },
  { email: 'alice@local.test', label: 'Alice Martin (dev)' },
  { email: 'bob@local.test', label: 'Bob Leroy (dev)' },
  { email: 'chloe@local.test', label: 'Chloé Bernard (dev, 80 %)' },
  { email: 'david@local.test', label: 'David Moreau (freelance)' },
  { email: 'emma@local.test', label: 'Emma Petit (CDD)' },
  { email: 'felix@local.test', label: 'Félix Roux (alternant)' },
];

export async function devLogin(email) {
  const { error } = await supabase.auth.signInWithPassword({ email, password: 'password' });
  return error ? 'Bypass login impossible : ' + error.message : '';
}

// Local et preprod : connexion email + mot de passe pour les comptes de test (tests Kuste de la
// pipeline). REACT_APP_MOMO_ENV est injecté au démarrage du conteneur (MOMO_ENV du .env serveur) :
// absent ou "production" → masqué. La prod garde aussi EMAIL_LOGIN_ENABLED=false côté serveur,
// qui y refuse tout mot de passe.
export const TEST_LOGIN_ENABLED = ['local', 'preprod', 'preproduction'].includes(
  (process.env.REACT_APP_MOMO_ENV || '').toLowerCase(),
);

export async function testLogin(email, password) {
  const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
  return error ? 'Connexion impossible : ' + error.message : '';
}
